/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const VLINDER_LOGO = require("./res/images/vLogo.png");
export const KLEFKI_LOGO = require("./res/images/klefki.png");

export const DUMMY_IMAGE = require("./res/images/300-300.png");
export const ORDINARY_DAY_IMAGE = require("./res/images/ordinary-day.png");
export const VLINDER_IMAGE = require("./res/images/vlinder-logo.png");

export const GOLD_ICON = require("./res/images/gold.png");
export const PLATINUM_ICON = require("./res/images/platinum-1.png");
export const DIAMOND_ICON = require("./res/images/diamond.png");

export const LOADING_IMAGE = require("./res/images/loading-img.png");

export const EMPTY_IMAGE = require("./res/images/empty.png");

export const SOUND = require("./res/images/sound.png");
export const Image_3D = require("./res/images/3D_image.png");
export const musicButton = require("./res/images/music-button.png");
export const videoButton = require("./res/images/video-button.png");
export const button3D = require("./res/images/3d-button.png");

export const NO_ASSET = require("./res/images/no-data.svg");

export const CREATED = require("./res/images/create.png");
export const LISTED = require("./res/images/listing.png");
export const MINTED = require("./res/images/minted.png");
export const ANCHOR = require("./res/images/anchor.png");

export const ETHER = require("./res/images/ether.png");
export const MATIC = require("./res/images/matic.png");

export const BANNER_IMAGE = require("./res/images/bg.png");

export const A1_TELECOM_BANNER_IMAGE = require("./res/images/A1_bg.png");
export const A1_TELECOM_BANNER_BG_IMAGE = require("./res/images/A1_Skiing_BG.png");

export const DIAGEO_BANNER_IMAGE = require("./res/images/diageo_bg.png");

export const SWISS_TIMING_LOGO = require("./res/images/swiss_timing_logo.png");
export const SWISS_TIMING_WHITE_LOGO = require("./res/images/swiss_timing_logo.png");
export const SWISS_TIMING_CROSS_LOGO = require("./res/images/swiss_timing_sy.png");

export const A1_TELECOM_LOGO = require("./res/images/A1_TELECOM_LOGO.png");
export const DIAGEO_HEADER_LOGO = require("./res/images/diageo_header-logo.png");
export const DIAGEO_FOOTER_LOGO = require("./res/images/diageo_footer-logo.png");

//diageo_india-logo.png
export const A1_SPORTS_BLACK_LOGO_1 = require("./res/images/A1_Sports_DRAGON_BLACK_1.png");
export const A1_SPORTS_BLACK_LOGO = require("./res/images/A1_Sports_DRAGON_BLACK.png");
export const A1_SPORTS_GREEN_LOGO = require("./res/images/A1_Sports_DRAGON_GREEN.png")
export const A1_SPORTS_BROWN_LOGO = require("./res/images/A1_Sports_DRAGON_BROWN.png")
export const A1_SPORTS_RED_LOGO = require("./res/images/A1_Sports_DRAGON_RED.png")

export const OMEGA_BANNER_IMG = require("./res/images/omega-banner.png");
export const LONGINES_BANNER_IMG = require("./res/images/longines.png");
export const TISSOT_BNNER_IMG = require("./res/images/tissot.png");

export const RC_RCB_BANNER_IMG = require("./res/images/rc-rcb-banner.png");
export const YAARI_BANNER_IMG = require("./res/images/yaari_bg.png");
export const EPITOME_BANNER_IMG = require("./res/images/EPITOME_BG.jpeg");
export const JC_BANNER_IMG = require("./res/images/jw_banner.png");




export const A1_BANNER_IMG = require("./res/images/A1_Logo_Similar_Omega_Detail_Screen.jpg");


export const IMAGES = [
    VLINDER_LOGO,
    KLEFKI_LOGO,
    DUMMY_IMAGE,
    ORDINARY_DAY_IMAGE,
    VLINDER_IMAGE,

    GOLD_ICON,
    PLATINUM_ICON,
    DIAMOND_ICON,

    LOADING_IMAGE,
    EMPTY_IMAGE,
    NO_ASSET,

    CREATED,
    LISTED,
    MINTED,
    ANCHOR,

    ETHER,
    MATIC,
];
